module.exports = __webpack_public_path__ + "static/img/xh2.9a53358.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xh2.png
// module id = pUt4
// module chunks = 0